export interface Note {
  slug: string;
  series: string;   // groups related chunks together, e.g. all "ClickHouse" notes
  order: number;    // reading order within the series
  title: string;    // the chunk's own focused topic, e.g. "What is a Span?"
  summary: string;
  tags: string[];
  color: string;
  status: 'Published' | 'Coming soon';
}

// Small, focused chunks — one topic per note, basic to depth. Each opens as its own
// full page (never several topics crammed into one). Add new entries here (and their
// content in pages/NoteDetail.tsx) as you learn more tech.
export const notes: Note[] = [
  {
    slug: 'what-is-clickhouse',
    series: 'ClickHouse',
    order: 1,
    title: 'What is ClickHouse?',
    summary: 'The 30-second definition — what it is, who built it, and what it\'s actually for.',
    tags: ['Database', 'OLAP'],
    color: '#00e5c8',
    status: 'Published',
  },
  {
    slug: 'why-clickhouse-for-observability',
    series: 'ClickHouse',
    order: 2,
    title: 'Why We Need ClickHouse in Observability',
    summary: 'Row store vs. column store, explained with a live visual you can run yourself.',
    tags: ['Observability', 'OLAP'],
    color: '#00e5c8',
    status: 'Published',
  },
  {
    slug: 'what-is-a-span',
    series: 'ClickHouse',
    order: 3,
    title: 'What is a Span?',
    summary: 'The building block of distributed tracing, and why it maps so cleanly onto a ClickHouse row.',
    tags: ['Observability', 'Tracing'],
    color: '#00e5c8',
    status: 'Published',
  },
];
